import React from 'react';
import times from 'lodash/times';
import { Shimmer } from '../../../../../../../../../CommonComponents/OPL/Shimmer/Shimmer';
import {
  TableBody,
  TableCell,
  TableHeader,
  TableRow,
} from '../../../../../../../../../CommonComponents/OPL/Table/Table';

export const TransfersLoading = () => {
  return (
    <>
      <TableHeader height={48}>
        <TableRow />
      </TableHeader>

      <TableBody>
        {times(3).map(i => (
          <TableRow key={i}>
            <TableCell width="11%">
              <Shimmer width={79} height={24} my={10} />
            </TableCell>
            <TableCell width="33%">
              <Shimmer width={189} height={24} my={10} />
            </TableCell>
            <TableCell width="20%">
              <Shimmer width={98} height={24} my={10} />
            </TableCell>
            <TableCell width="29%" justifyContent="end">
              <Shimmer width={114} height={24} my={10} />
            </TableCell>
            <TableCell width="7%" justifyContent="center">
              <Shimmer width={24} height={24} my={10} />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </>
  );
};
